export function jsonStringifyOrUndefined<T>(
  valueToEncode: T
): string | undefined {
  try {
    // This is the only place in the project where JSON.stringify is allowed
    // eslint-disable-next-line no-restricted-properties
    return JSON.stringify(valueToEncode);
  } catch (e) {
    console.error("Failed to encode given value to JSON", e);
    return undefined;
  }
}
